import type { VfConfig } from '#types/config/components/vf'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    clear: 'px-1 py-2 -mr-3',
    form: 'b-b',
    input: 'b-0 h-10 [&_label]:pl-1',
    submit: 'p-1'
  }
} satisfies RecursivePartial<VfConfig['searchBar']>
